import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  useTheme,
  IconButton,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import dentalTheme from "../../../theme1";

const navItems = [
  { label: "Home", href: "#hero" },
  { label: "About Us", href: "#about-us" },
  { label: "Services", href: "#services" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Smile Gallery", href: "#smile-gallery" },
  { label: "Patient Info", href: "#patient-info" },
  { label: "Contact Us", href: "#contact-us" },
];

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Detect if screen size is small

  const [drawerOpen, setDrawerOpen] = useState(false); // State to manage drawer open/close

  const toggleDrawer = (open: boolean | ((prevState: boolean) => boolean)) => () => {
    setDrawerOpen(open);
  };

  const drawerContent = (
    <Box
      sx={{
        width: 250,
        backgroundColor: "white",
        height: "100%",
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {navItems.map((item) => (
          <ListItem button key={item.label} component="a" href={item.href}>
            <ListItemText
              primary={item.label}
              sx={{
                textTransform: "none",
                color: dentalTheme.palette.primary.main,
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "white",
        width: "100%",
        position: "absolute",
        top: 0,
        boxShadow: "none",
        zIndex: 9,
        px: isMobile ? theme.spacing(6) : theme.spacing(12),
      }}
    >
      <Toolbar
        sx={{
          backgroundColor: "transparent",
          justifyContent: "space-between",
          px: 0, // Directly target the padding on the Toolbar itself
        }}
      >
        {/* Logo aligned to the left */}
        <img src="/dental-logo.png" width={45} height={45} alt="Logo" />

        {/* Conditionally render the nav items or the Menu icon based on screen size */}
        {!isMobile ? (
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-start" }}>
            {navItems.map((item) => (
              <Button
                key={item.label}
                color="inherit"
                href={item.href}
                sx={{
                  textTransform: "none",
                  color: dentalTheme.palette.primary.main,
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        ) : (
          <>
            {/* Menu icon for small screens */}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ color: dentalTheme.palette.primary.main }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>

            {/* Drawer for mobile navigation */}
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
              {drawerContent}
            </Drawer>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
